import React from 'react';
import { MutationFn } from 'react-apollo';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import CoachingCoordinatorPeopleView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorPeopleView';
import CoachingCoordinatorSessionsView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorSessionsView';
import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import { GetParticipantList_coaching_getParticipantList_participants } from 'coaching/queries/__generated__/GetParticipantList';
import { GetCoachList_coaching_getCoachList_coaches } from 'coaching/queries/__generated__/GetCoachList';
import {
  CreateCoachingSession,
  CreateCoachingSessionVariables,
} from 'coaching/mutations/__generated__/CreateCoachingSession';

import '../styles/CoachingCoordinatorView.scss';
import 'admin/components/styles/AdminUpgradePageHeader.scss';

export type PeopleViewProps = {
  loadingParticipants: boolean;
  participantsError?: string;
  participants?: GetParticipantList_coaching_getParticipantList_participants[];
  selectedParticipant?: GetParticipantList_coaching_getParticipantList_participants;
  onSelectParticipant: (
    participant: GetParticipantList_coaching_getParticipantList_participants
  ) => void;
  participantPagination: {
    onNextPage: () => Promise<void>;
    hasNextPage?: boolean;
  };

  coaches?: GetCoachList_coaching_getCoachList_coaches[];
  loadingCoaches: boolean;
  coachesError?: string;
  coachPagination: {
    onNextPage: () => Promise<void>;
    hasNextPage?: boolean;
  };

  loadingCancellationReasons: boolean;
  cancellationReasonsError?: string;
  cancellationReasons: string[];

  onCreateCoachingSession: MutationFn<CreateCoachingSession, CreateCoachingSessionVariables>;
};

export type Props = PeopleViewProps;

type TabName = 'sessions' | 'people';

type State = {
  tab: TabName;
};

export default class CoachingCoordinatorView extends React.Component<Props, State> {
  state: State = {
    tab: 'people',
  };

  handleListTabsChange = (tab: TabName) => {
    this.setState({ tab });
  };

  render() {
    const { tab } = this.state;
    const components = {
      people: {
        component: CoachingCoordinatorPeopleView,
        props: this.props,
      },
      sessions: {
        component: CoachingCoordinatorSessionsView,
        props: this.props,
      },
    };
    const ComponentToRender = components[tab].component;
    return (
      <div className="CoachingCoordinatorView">
        <div className="AdminUpgradePageHeader">
          <div className="AdminUpgradePageHeader-container">
            <div className="AdminUpgradePageHeader-items">
              <MediaObject center gutter="xxxxlarge">
                <Glyph name="remind-icon" color="koolaid" size="xxlarge" solo />
                <Buttons margin="xxxxlarge">
                  <Button
                    weight="semibold"
                    level="text"
                    size="xxsmall"
                    onClick={() => this.handleListTabsChange('sessions')}>
                    <Text color={tab === 'sessions' ? 'pitch' : 'thunder'} size="small">
                      Sessions
                    </Text>
                  </Button>
                  <Button
                    weight="semibold"
                    level="text"
                    size="xxsmall"
                    onClick={() => this.handleListTabsChange('people')}>
                    <Text color={tab === 'people' ? 'pitch' : 'thunder'} size="small">
                      People
                    </Text>
                  </Button>
                </Buttons>
              </MediaObject>
            </div>
          </div>
        </div>
        <div className="CoachingCoordinatorView-body">
          <ComponentToRender {...components[tab].props} />
        </div>
      </div>
    );
  }
}
